import { render, staticRenderFns } from "./popCom.vue?vue&type=template&id=7e089dd6&"
import script from "./popCom.vue?vue&type=script&lang=js&"
export * from "./popCom.vue?vue&type=script&lang=js&"
import style0 from "./popCom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports